import { React, useState, useEffect } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import TagItem from './TagItem';
import { useDrop } from 'react-dnd';
import { UserTagStatus } from '../classes/UserTag';

const tagStatus = new UserTagStatus;


export default function TagList(props) {

    const [ items, setItems ] = useState({});

    useEffect(() => {
        // console.log(`TagList.useEffect(): ${props.tagType} items: ${Object.keys(props.items).length}`);
        setItems(props.items);
    }, [props.items, props.itemCount])

    const moveTag = ((item, monitor) => {
         // console.log(`TagList.moveTag(${JSON.stringify(item)})`);
         props.tagMover(item.tagId, item.tagType, props.tagType);
    });

    const [{dragItem, isOver}, drop] = useDrop(() => ({
        accept: 'TAG',
        drop: (itm, mon) => moveTag(itm, mon),
        collect: (monitor) => ({
            dragItem: monitor.getItem(),
            isOver: !!monitor.isOver()
        })
    }),
    [props.items, props.itemCount]
    )



return(
<Card.Body ref={drop} className="border" style={{'overflow-y': 'auto'}}>
    <ListGroup>
    {Object.keys(items).map((tagId) => (
        <TagItem id={tagId} tagType={props.tagType} tagId={tagId} itemCount={props.itemCount}/>
    ))}
    </ListGroup>
</Card.Body>
)
}